module.exports = __webpack_public_path__ + "img/fabrixapi-booth-video.0b3bba28.jpg";